import axios, { AxiosError } from 'axios';

const instance = axios.create({
  baseURL: import.meta.env.VITE_FELO_API_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use(
  (config: any) => {
    // 处理重复请求
    // const token = window.localStorage.getItem('subtitlestoken');
    return config;
  },
  (error) => Promise.reject(error),
);

instance.interceptors.response.use(
  (response) => {
    // 移除重复请求
    return response;
  },
  (error: AxiosError) => {
    // 移除重复请求
    return Promise.reject(error);
  },
);

export default instance;
